import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { baseURL } from "../../BaseUrl";
// Function to retrieve token from localStorage
const getToken = () => localStorage.getItem("workManagement");

// API headers including token
const getAuthHeaders = () => ({
  headers: {
    Authorization: `Bearer ${getToken()}`,
  },
});
export const getAllworktrackdata = createAsyncThunk(
    "workTrack/getAllworktrackdata",
    async () => {
      try {
        // console.log("authtnk", getAuthHeaders())
        const response = await baseURL.get(`/tracking/`,getAuthHeaders());
        // console.log("response.data", response.data);
        return response.data.data;
      } catch (error) {
        // alert(`${error.response.data.message}`)
        throw error; // Ensure the error is propagated
      }
    }
  );
  //get the work tract pdf by sending the wm_work_orders_id
  export const createWorkTrackDataPDF = createAsyncThunk(
    "work/createWorkTrackDataPDF",
    async (work_order_numb) => {
      try {
        const response = await baseURL.post(`/tracking/work-tracking-pdf`,work_order_numb,getAuthHeaders()
        );
        // console.log("response.data", response.data);
        return response.data;
      } catch (error) {
        // alert(`${error.response.data.message}`)
        throw error; // Ensure the error is propagated
      }
    }
  );
//   export const getSingleworkdata = createAsyncThunk(
//     "work/getSingleworkdata",
//     async (id) => {
//       try {
//         // console.log("authtnk", getAuthHeaders())
//         const response = await baseURL.get(`/work-order/${id}`,getAuthHeaders());
//         console.log("response.data", response.data);
//         return response.data.data;
//       } catch (error) {
//         // alert(`${error.response.data.message}`)
//         throw error; // Ensure the error is propagated
//       }
//     }
//   );
//   export const updateworkdata = createAsyncThunk(
//     "work/updateworkdata",
//     async (data) => {
//       try {
//         // console.log("authtnk", getAuthHeaders())
//         const response = await baseURL.patch(`/work-order/`,data,getAuthHeaders()
//         );
//         // console.log("response.data", response.data);
//         return response.data.data;
//       } catch (error) {
//         // alert(`${error.response.data.message}`)
//         throw error; // Ensure the error is propagated
//       }
//     }
//   );
  export const worktrackSlice = createSlice({
    name: "workTrack",
    initialState: {
      worktrackData: [],
      loading: false,
      error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
      builder
        .addCase(getAllworktrackdata.pending, (state) => {
          state.loading = true;
        })
        .addCase(getAllworktrackdata.fulfilled, (state, action) => {
          state.loading = false;
          state.worktrackData = action.payload;
        })
        .addCase(getAllworktrackdata.rejected, (state, action) => {
          state.loading = false;
          state.error = action.error;
        });
        // builder
        // .addCase(getSingleworkdata.pending, (state) => {
        //   state.loading = true;
        // })
        // .addCase(getSingleworkdata.fulfilled, (state, action) => {
        //   state.loading = false;
        //   state.singleWorkData = action.payload;
        // })
        // .addCase(getSingleworkdata.rejected, (state, action) => {
        //   state.loading = false;
        //   state.error = action.error;
        // });
    },
  });
  
  // SELECTORS
  export const getWorkTrackData = (state) => state.workTrack.worktrackData;
//   export const getUniqueWorkData = (state) => state.work.singleWorkData;
    export const worktrackerror = (state) => state.work.loading;
  
  // EXPORTS
  export default worktrackSlice.reducer;
  